
namespace Core.AdHoc {

    /// Duration unit enum
    export enum DurationUnitSingular {
        Hour = 1, Day
    }

    export enum DurationUnitPlural {
        Hours = 1, Days
    }

    export interface AdHocAvailabilityType {
        Id: number;
        Title: string;
    }

    export interface AdHocProductTypesRequest {
        CultureCode: string;
        DomainId: number;
    }

    /// availability/get
    export interface AdHoc {
        AvailabilityId: string;
        AdHocOptions: AdHocOptions[];
    }

    export interface AdHocOptions {
        Id: number;
        TypeId: number;
        Supplier: Supplier;
        Title: string;
        CanOverrideTitle: boolean;
        RequiresPassengers: boolean;
        RequiresQuantity: boolean;
        RequiresSupplierRef: boolean;
        SupplierUnitCost: number;
        SupplierChildCost: number;
        SupplierCurrency: string;
        CanOverrideSupplierCost: boolean;
        PickUpLocation: string;
        DropOffLocation: string;
        Availability: AdHocAvailability[];
        ClientUnitCost: number;
        ClientChildCost: number;
        ClientCurrency: string;
        CanOverrideClientCost: boolean;
        MaximumChildAge: number;
        Duration: AdHocDuration;
        IsDateSpecific: boolean;
        IsBookable: boolean;
        CanOverrideCommission: boolean;
        Itinerary: AdHocItinerary[];
    }

    export interface AdHocAvailability {
        Date: string;
        SupplierUnitCost: number;
        SupplierChildCost: number;
        ClientUnitCost: number;
        ClientChildCost: number;
        Timing: AdHocTiming[];
    }

    export interface AdHocTiming {
        StartTime: string;
        EndTime: string;
    }

    export interface AdHocDuration {
        Amount: number;
        Unit: number;
    }

    export interface AdHocItinerary {
        Id: number;
        ItemTime: string;
        Description: string;
    }


    /// availability/get request payload
    export interface AdHocAvailabilityRequest {
        CultureCode: string;
        CurrencyCode: string;
        DomainId: number;
        IsFlightPlus: boolean;
        ProductTypeId: number;
        StartDate: Date;
        EndDate: Date;
        SearchTerm?: string;
    }


    /// Used in api/adhoc/details/get
    export interface AdHocDetailsGetRequest {
        AvailabilityId: string;
        Product: {
            Id: string;
            ProductId: number | null;
            Title: string | null;
            Date: string | null;
            Time: string;
            Adults: number;
            ChildAges: number[];
            Quantity: number;
            SupplierRef: string | null;
            SupplierUnitCost: number | null;
            SupplierChildCost: number | null;
            ClientUnitCost: number | null;
            ClientChildCost: number | null;
            ManualCommissionAmount: number | null;
            PickUpLocation: string | null;
            DropOffLocation: string | null;
        };
    }

    export interface AdHocDetailsGetResponse {
        AvailabilityId: string;
        DetailsId: string;
        Product: {
            Id: string;
            ProductId: number;
            TypeId: number;
            SupplierId: number;
            Title: string;
            StartDate: Date;
            EndDate: Date;
            Adults: number;
            ChildAges: number[];
            Quantity: number;
            SupplierRef: string;
            SupplierUnitCost: number;
            SupplierChildCost: number;
            ClientUnitCost: number;
            ClientChildCost: number;
            PickUpLocation: string;
            DropOffLocation: string;
            ManualCommissionAmount: number;
            Duration: AdHocDuration;
            Itinerary: AdHocItinerary[];
            IsBookable: boolean;
            IsHidden: boolean;
            IsPriceHidden: boolean;
        };
    }

    export interface AdHocAdjustmentRequest {
        BasketId: string;
        AdjustmentId: number;
        Title: string;
        SupplierUnitCost: number;
        SupplierChildCost: number;
        ClientUnitCost: number;
        ClientChildCost: number;
        ManualCommissionAmount: number;
        ExpectedVersion: number;
    }

    export interface Supplier {
        Id: number;
        Name: string;
    }

    export interface Occupancy {
        Adults: number;
        ChildAges: number[];
    }

    export interface BookedItem {
        ProductTypeId: number;
        SupplierId: number;
        Title: string;
        SupplierCost: number;
        ClientCost: number;
        ClientCurrency: string;
        ManualCommissionAmount?: number;
    }
}
